<!--
 * @Description:payload 1搜索购买、2主页（快速）购买、3推荐栏购买
 * @Author: cooky
 * @Date: 2021-02-26 19:08:49
 * @LastEditors: cooky
 * @LastEditTime: 2021-04-12 10:02:23
-->
<template>
  <div class="buying">
    <div class="buying-body">
      <div class="layout-between buying-info">
        <div class="info-title" v-if="isPc || !isOnSearch">{{ $t('quick_buy') }}</div>
        <Searchbox @change="handleSearch" v-if="!isPc" class="searchbox-mobile"/>
        <!-- {{ isOnSearch }} -->
        <div class="buying-role" :class="{'goods-item': !isPc}" v-if="isPc || !isOnSearch">
          <div>{{ $t('hello') }}，<span>【{{ serverName }}】</span> {{ roleName }}</div>
          <a class="btn-change" @click="handleChangeRole"><i class="icon icon-change"/>{{ $t('change_role') }}</a>
        </div>
      </div>
      <div class="layout-between buying-top">
        <div class="buying-tab" v-if="!isOnSearch">
          <span v-for="tab in tabList" :key="tab.key" :class="{active: tab.key === activeTabKey}" @click="changeTab(tab.key)">{{ tab.title }}</span>
        </div>
        <div class="buying-tab buying-tab--sort" v-else-if="isPc || searchResultGoodsList.length > 0">
          <span v-for="tab in tabSortList" :key="tab.key" :class="{active: tab.key === activeSortTabKey}" @click="changeTab(tab.key, 'activeSortTabKey')">
            {{ tab.title }} {{ tab.type === 'sort' ? (priceSort === 'desc' ? '↓':'↑') : '' }}
          </span>
        </div>
        <Searchbox @change="handleSearch" v-if="isPc"/>
      </div>
      <!-- 主页商品 -->
      <GoodsList :list="goodsList" v-if="!isOnSearch" :showEmpty="true" payload="2"/>
      <!-- 搜索结果商品 -->
      <GoodsList :list="searchResultGoodsList" :showEmpty="!!searchText" v-else payload="1"/>
      <!-- 相关推荐商品 -->
      <div v-if="isOnSearch && this.searchResultGoodsList.length === 0" class="buying-recomand">
        <div class="info-title">{{ $t('recommend') }}</div>
        <GoodsList :list="recommandList" payload="3"/>
      </div>
    </div>
    <ChangeRoleModal :visible.sync="visible" v-if="visible"/>
  </div>
</template>
<script>
import ButtomInfo from './BottomInfo'
import GoodsList from './GoodsList'
import Searchbox from './Searchbox'
import ServerRole from '../infoBinding/ServerRoleForm'
import { mapState, mapGetters } from 'vuex'
import { getCommodity, queryPayingStatus } from '@/api'
import { getUid, setUid, parseQueryString } from '@/util/wrapperUtil'
import ChangeRoleModal from './ChangeRoleModal'
import Store from '@/store'

export default {
  name: 'Buying',
  components: { ButtomInfo, GoodsList, Searchbox, ServerRole, ChangeRoleModal },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState([
      'isPc',
      'lang'
    ]),
    ...mapGetters(['serverName', 'roleName'])
  },
  data () {
    return {
      visible: false,
      activeTabKey: 1,
      activeSortTabKey: 1,
      tabList: [{
        title: this.$t('tab1'),
        key: 1
      }, {
        title: this.$t('tab2'),
        key: 2
      }, {
        title: this.$t('tab3'),
        key: 3
      }],
      tabSortList: [{
        title: this.$t('default_sort'),
        key: 1
      }, {
        title: this.$t('price_sort'),
        key: 2,
        type: 'sort'
      }],
      searchText: '',
      goodsList: [],
      tempAllGoodsInfo: {}, // 保存的原始购买项,分类
      tempAllGoodsList: [], // 所有原始购买项
      recommandList: [],
      isOnSearch: false, // 是否处于搜索，搜索时，直接展示相关推荐，和搜索结果
      searchResultGoodsList: [],
      priceSort: '' // 价格排序，默认升序，点一下倒序desc
    }
  },
  async beforeRouteEnter (to, from, next) {
    const localeUid = getUid()
    if (to.query && to.query.uid && !localeUid) {
      next({ name: 'buying' })
    } else {
      next()
    }
  },
  async created () {
    this.init()
    await this.getCommodity()
    await this.queryPayingStatus()
    console.log(this.vizier.track_event)
  },
  watch: {
    roleName () { // 切换角色，重新获取购买项
      this.getCommodity()
      this.activeTabKey = 1
    },
    lang () {
      this.getCommodity()
      this.recommandList = []
      this.activeTabKey = 1
      this.tabList = [{
        title: this.$t('tab1'),
        key: 1
      }, {
        title: this.$t('tab2'),
        key: 2
      }, {
        title: this.$t('tab3'),
        key: 3
      }]
      this.tabSortList = [{
        title: this.$t('default_sort'),
        key: 1
      }, {
        title: this.$t('price_sort'),
        key: 2,
        type: 'sort'
      }]
    }
  },
  methods: {
    async init () {
      if (!sessionStorage.token) {
        this.$router.replace({ name: 'ThirdPartChannel' })
      } else if (!sessionStorage.roleId) {
        this.$router.replace({ name: 'RoleBinding' })
      } else {
        await Store.dispatch('GetAllRoles')
        const { serverName } = sessionStorage
        const { serverRoleList } = Store.getters
        if (!serverName || !serverRoleList.find(item => item.server_name === serverName)) {
          this.$router.replace({ name: 'InfoBinding' })
        }
      }
    },
    changeTab (key, field = 'activeTabKey') {
      if (field === 'activeTabKey') {
        this.goodsList = this.tempAllGoodsInfo[key]
      } else if (key === 1) {
        this.sortSearchResult(this.searchResultGoodsList)
      } else { // 排序tab
        this.priceSort = this.priceSort ? ['asc', 'desc'][+(this.priceSort === 'asc')] : 'asc'
        this.sortSearchResult(this.searchResultGoodsList, key === 1 ? 'default' : ('price' + this.priceSort))
      }
      this[field] = key
    },
    handleSearch (text, isOnSearch) {
      console.log('搜索=====', text, isOnSearch)
      this.isOnSearch = isOnSearch
      this.searchText = text
      if (!this.isOnSearch) {
        // this.goodsList = this.tempAllGoodsList[this.activeTabKey]
        this.activeSortTabKey = ''
        return
      }
      if (!text) {
        this.searchResultGoodsList = []
        return
      }
      if (!this.activeSortTabKey) this.activeSortTabKey = 1
      this.searchResultGoodsList = this.filterGoods(text) // this.tempAllGoodsList.filter(item => item.id < 3)
      // 上报埋点
      this.vizier.track_event('search_results', { is_empty: this.searchResultGoodsList.length === 0, search_key: text })
    },
    // 搜索过滤商品，按最高匹配倒序，价格小 -> 大, 商品id小 -> 大
    filterGoods (text) {
      const filterList = []
      this.tempAllGoodsList.map(item => {
        const title = item.product_name
        if (title.toLowerCase().indexOf(text.toLowerCase()) > -1) {
          filterList.push(item)
        }
      })
      return this.sortSearchResult(filterList)
    },
    // default 按最高匹配倒序，价格小 -> 大, 商品id小 -> 大
    sortSearchResult (list, type = 'default') {
      if (type === 'default') {
        return list.sort(function (a, b) {
          if (a.product_name.length === b.product_name.length) {
            if (a.price === b.price) {
              return a.id - b.id
            }
            return a.price - b.price
          }
          return a.product_name.length - b.product_name.length
        })
      } else if (type === 'priceasc') { // 价格升序
        return this.searchResultGoodsList.sort(function (a, b) {
          if (a.price === b.price) {
            return a.id - b.id
          }
          return a.price - b.price
        })
      } else if (type === 'pricedesc') { // 价格升序
        return this.searchResultGoodsList.sort(function (a, b) {
          if (a.price === b.price) {
            return a.id - b.id
          }
          return b.price - a.price
        })
      }
    },
    handleChangeRole () {
      this.visible = true
    },
    // 获取购买项列表
    async getCommodity () {
      const { code, data } = await getCommodity()
      if (code === 0) {
        const list = data.commodity_list
        this.tempAllGoodsList = JSON.parse(JSON.stringify(list))
        const tempAllGoodsInfo = {}
        list.forEach(item => {
          if (!tempAllGoodsInfo[item.tag]) {
            tempAllGoodsInfo[item.tag] = [item]
          } else {
            tempAllGoodsInfo[item.tag] = tempAllGoodsInfo[item.tag].concat(item)
          }
        })
        this.tempAllGoodsInfo = tempAllGoodsInfo
        this.goodsList = this.tempAllGoodsInfo[this.activeTabKey]

        this.getRecommandGoods()
      }
    },
    // 获取相关推荐
    async getRecommandGoods () {
      if (this.recommandList.length > 0) return

      this.recommandList = this.tempAllGoodsInfo[3]
    },
    async queryPayingStatus () {
      const queryObj = parseQueryString(location.search.slice(1))
      const localeUid = getUid()
      const incomingUid = queryObj.uid
      if (incomingUid && incomingUid === localeUid) {
        const { code, data: { result, wait, pay_result: payResult } } = await queryPayingStatus(incomingUid)
        console.log(result)
        if (code === 0) {
          if (!wait) {
            setUid(null)
            if (result) {
              this.$info({
                content: (h) => {
                  return (
                    <div>
                      {this.$t('pay_success')}
                    </div>
                  )
                },
                okText: this.$t('ok')
              })
            } else {
              this.$info({
                content: (h) => {
                  return (
                    <div>
                      <div>{payResult}</div>
                    </div>
                  )
                },
                okText: this.$t('ok')
              })
            }
          } else {
            setTimeout(() => {
              this.queryPayingStatus()
            }, 700)
          }
        }
      }
    }
  }
}
</script>
<style lang="less">
 @media screen and (max-width: 750px) {
    .buying {
      &-tab--sort {
        border-bottom: 0;
        span {
          flex: none;
          &.active {
            border: 0;
          }
        }
      }
    }
    .searchbox-mobile {
     margin-right: 2rem /* 15/7.5 */;
    }
    .searchbox.active {
      position: inherit;
      margin: 0 auto;
    }
    .recomand .info-title {
      margin: 2.6667rem 0 3.2rem 0;
    }
  }
</style>
